﻿import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setShowalert } from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";

export default function Alertinformation() {
  const { alertData, multiLanguageData } = useSelector((state) => state?.main);

  const dispatch = useDispatch();

  const { BUTTON_OK = English?.Home?.BUTTON_OK } = multiLanguageData?.Home || {};

  const handleClose = () => {
    let alertObj = {
      showAlert: false,
      title: "",
      text: ""
    };
    dispatch(setShowalert(alertObj));
  };

  return (
    <Modal open={alertData?.showAlert ?? false} closeAfterTransition>
      <Box className="user-modal-responsive">
        <Stack sx={{ gap: 1 }} >
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            {alertData?.title}
          </Typography>
          <Typography variant="body1">{alertData?.text}</Typography>
          <Typography variant="body1">{alertData?.text2}</Typography>
        </Stack>
        <Button
          variant="contained"
          className="action-button"
          onClick={() => handleClose()}
          style={{ float: "right" }}>
          {BUTTON_OK}
        </Button>
      </Box>
    </Modal>
  );
}

